var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-analytics__disclaimer"},[(!_vm.isMobile && !_vm.isTablet)?_c('gl-icon',{attrs:{"gray":"","height":14,"hover":false,"name":"info","width":14}}):_vm._e(),_vm._v(" All TMs indicated herein are for reference purposes only and in accordance with Art. 15 Swiss Trademark Protection Act. ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }